import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';

import { LoginService } from '../services/login.service';
import { UserLogin } from '../models/user.login';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const loginService = inject(LoginService);

  const expectedRoleArray = route.data['expectedRole'];

  console.log('===== AUTH GUARD =====');
  console.log('Requested URL:', state.url);
  console.log('Expected Roles:', expectedRoleArray);

  // Common authorization check
  const checkAuthorization = (): boolean => {

    const userEmail =
      localStorage.getItem('UserEmail');

    const selectedVendor =
      localStorage.getItem('selectedVendor');

    const userRoleInfo =
      localStorage.getItem('UserRoleInfo');

    console.log('UserEmail:', userEmail);
    console.log('selectedVendor:', selectedVendor);
    console.log('UserRoleInfo exists:', !!userRoleInfo);

    if (
      userEmail == null ||
      selectedVendor == null ||
      userRoleInfo == null
    ) {
      return false;
    }

    const decodedUserRoleInfo: UserLogin =
      JSON.parse(atob(userRoleInfo));

    console.log(
      'Actual User Roles:',
      decodedUserRoleInfo.roles
    );

    return decodedUserRoleInfo.roles.some(
      (role: any) =>
        expectedRoleArray.includes(role.roleKey)
    );
  };


  // ------------------------------------------
  // Existing session is already available
  // ------------------------------------------

  if (checkAuthorization()) {

    console.log(
      'AUTH GUARD ALLOWED:',
      state.url
    );

    return true;
  }


  // ------------------------------------------
  // Existing/custom authentication
  // ------------------------------------------

  if (!environment.authentication.useAzureAd) {

    console.log(
      'Custom authentication - redirecting to login'
    );

    return router.createUrlTree(['/login']);
  }


  // ------------------------------------------
  // Azure authentication
  // RetailHub session may not be loaded yet
  // ------------------------------------------

  console.log(
    'Azure mode - loading RetailHub user...'
  );

  return loginService.getCurrentUser().pipe(

    map((data: any) => {

      const vendors = data?.vendors || [];

      // Populate the same values used by the
      // existing RetailHub application
      localStorage.setItem(
        'UserEmail',
        data.userEmail
      );

      localStorage.setItem(
        'UserRoleInfo',
        btoa(JSON.stringify(data))
      );

      localStorage.setItem(
        'UserInfo',
        JSON.stringify(data)
      );

      localStorage.setItem(
        'UserDisplayName',
        `${data.firstname ?? ''} ${data.lastname ?? ''}`.trim()
      );


      // Preserve existing selectedVendor contract
      if (vendors.length === 1) {

        localStorage.setItem(
          'selectedVendor',
          JSON.stringify(vendors[0])
        );
      }


      // Check authorization again now that
      // RetailHub session is initialized
      if (checkAuthorization()) {

        console.log(
          'AUTH GUARD ALLOWED AFTER USER LOAD:',
          state.url
        );

        return true;
      }


      console.log(
        'AUTH GUARD REJECTED AFTER USER LOAD:',
        state.url
      );

      return router.createUrlTree([
        '/unauthorized'
      ]);
    }),

    catchError((error) => {

      console.error(
        'Unable to load RetailHub user:',
        error
      );

      return of(
        router.createUrlTree([
          '/unauthorized'
        ])
      );
    })
  );
};